module.exports = __webpack_public_path__ + "static/media/iii-red-compartida.ad38e638.pdf";